<template>
  <base-layout toolbarActive>
    <template #toolbarBase>
      <div v-if="!advMobile">
        <router-link
          :to="{ name: 'advCreate' }"
          class="link font-weight-medium"
        >
          <icon-plus></icon-plus> Добавить новую рекламную кампанию
        </router-link>
      </div>
      <v-layout v-if="advMobile" justify-space-between align-center>
        <span class="font-weight-bold display-2"> Рекламные кампании </span>
        <button class="add-adv">
          <router-link :to="{ name: 'advCreate' }">
            <icon-plus
              class="mx-2 my-2"
              :color="
                $store.getters.themeDark ? '#FFFFFF' : $vuetify.theme.primary
              "
            ></icon-plus>
          </router-link>
        </button>
      </v-layout>
      <v-flex class="layout justify-end align-center" v-if="!advMobile">
        <advertising-filter></advertising-filter>
      </v-flex>
    </template>

    <hint-widget
      hintName="advertising"
      type="text"
      class="mx-4 mb-3"
      btnMore
    ></hint-widget>

    <v-container
      class="fluid pt-0"
      :class="{ 'px-0': advMobile, 'grid-list-xl': !advMobile }"
    >
      <v-layout wrap>
        <v-expansion-panel
          :value="panel"
          :readonly="!advMobile"
          expand
          class="pt-2 justify-start"
        >
          <div class="flex md4 sm6 xs12 adv-panel">
            <new-card-for-add :card="newAdvCard"></new-card-for-add>
          </div>
          <v-flex
            v-for="(adv, index) in advFilteredList"
            :key="adv.id"
            class="md4 sm6 xs12 adv-panel"
            :class="{ 'py-0 px-0 border-dark': advMobile }"
          >
            <advertising-item :id="adv.id" :index="index"></advertising-item>
          </v-flex>
        </v-expansion-panel>
      </v-layout>
    </v-container>
  </base-layout>
</template>

<script>
import AdvertisingItem from "../components/advertising/AdvertisingItem.vue";
import AdvertisingFilter from "../components/advertising/AdvertisingFilter";
import BaseLayout from "../components/layout/BaseLayout.vue";
import IconPlus from "../components/icon/IconPlus.vue";
import HintWidget from "../components/common/HintWidget.vue";
import NewCardForAdd from "../components/common/NewCardForAdd.vue";

export default {
  name: "AdvertisingView",

  components: {
    IconPlus,
    BaseLayout,
    AdvertisingItem,
    AdvertisingFilter,
    HintWidget,
    NewCardForAdd,
  },

  data: () => ({
    panel: [],
    // информация на карточке создания новой рекламы
    newAdvCard: {
      title: "Создать новую рекламную кампанию",
      action: "advCreate",
      description: "",
    },
  }),

  methods: {},
  watch: {
    // отслеживаем Expansion Panel, так как  при удалении из нее itemов она не верно обновляется
    // и из верстки пропадает болшее количество элементов, чем должно
    panel() {
      if (!this.advMobile && this.panel.length !== this.advFilteredList.length)
        this.panel = Array(
          this.$store.getters.advList(this.$store.getters.advFilter).length
        ).fill(true);
    },
    // тоже для Expansion Panel
    advFilteredList: function () {
      if (!this.advMobile) {
        this.panel = Array(
          this.$store.getters.advList(this.$store.getters.advFilter).length
        ).fill(true);
      }
    },
  },
  mounted() {
    this.$store.commit("SET_ADV_IS_LOADED", false);
    this.$store.dispatch("advListLoad");
    this.$store.dispatch("hotspotListLoad");
  },
  computed: {
    // отфильтрованный список рекламы
    advFilteredList() {
      return this.$store.getters.advList(this.$store.getters.advFilter);
    },
    // для expandPanel, все плашки только для чтения (не сворачиваются)
    advMobile() {
      return ["xs"].includes(this.$vuetify.breakpoint.name);
    },
  },
};
</script>
